import React from 'react'
import RenderLinkDash from '../../../pages/RenderLinkDash'
import B2B_Contratos from '../../../DashNativos/B2B_Contratos'
import B2B_CotacaoContratos from '../../../DashNativos/B2B_CotacaoContratos'
import B2B_CotacaoVendas from '../../../DashNativos/B2B_CotacaoVendas'
import B2B_FaturaContratos from '../../../DashNativos/B2B_FaturaContratos'
import B2B_HistoricoTitulos from '../../../DashNativos/B2B_HistoricoTitulos'
import B2B_Maquinas from '../../../DashNativos/B2B_Maquinas'
import B2B_MovimentacoesFiscais from '../../../DashNativos/B2B_MovimentacoesFiscais'
import B2B_ContasPagarReceberEmAberto from '../../../DashNativos/B2B_ContasPagarReceberEmAberto'
import B2B_NotaFiscal from '../../../DashNativos/B2B_NotaFiscal'
import B2B_NotaFiscalServico from '../../../DashNativos/B2B_NotaFiscalServico'
import B2B_OrdemServico from '../../../DashNativos/B2B_OrdemServico'
import B2B_PedidosPDV from '../../../DashNativos/B2B_PedidosPDV'
import B2B_TitulosPendentesVencidos from '../../../DashNativos/B2B_TitulosPendentesVencidos'

function ReturnDashNativos(vCarrossel, dadosDash) {
    const DashSelecionado = dadosDash.filter(d => d.Id === vCarrossel.IdDashboardSelecionado)
    if (DashSelecionado.length > 0) {

        if (DashSelecionado[0].LinkDash !== '') {
            return (
                <div className='h-full'>
                    <RenderLinkDash LinkDash={DashSelecionado[0].LinkDash} />
                </div>
            )
        }

        if (DashSelecionado[0].Descricao === 'B2B_Contratos') {
            return (
                <B2B_Contratos
                    NomeAmigavel={DashSelecionado[0].NomeAmigavel}
                />
            )
        }

        if (DashSelecionado[0].Descricao === 'B2B_CotacaoContratos') {
            return (
                <B2B_CotacaoContratos
                    NomeAmigavel={DashSelecionado[0].NomeAmigavel}
                />
            )
        }

        if (DashSelecionado[0].Descricao === 'B2B_CotacaoVendas') {
            return (
                <B2B_CotacaoVendas
                    NomeAmigavel={DashSelecionado[0].NomeAmigavel}
                />
            )
        }

        if (DashSelecionado[0].Descricao === 'B2B_HistoricoTitulos') {
            return (
                <B2B_HistoricoTitulos
                    NomeAmigavel={DashSelecionado[0].NomeAmigavel}
                />
            )
        }

        if (DashSelecionado[0].Descricao === 'B2B_Maquinas') {
            return (
                <B2B_Maquinas
                    NomeAmigavel={DashSelecionado[0].NomeAmigavel}
                />
            )
        }

        if (DashSelecionado[0].Descricao === 'B2B_MovimentacoesFiscais') {
            return (
                <B2B_MovimentacoesFiscais
                    NomeAmigavel={DashSelecionado[0].NomeAmigavel}
                />
            )
        }

        if (DashSelecionado[0].Descricao === 'B2B_ContasPagarReceberEmAberto') {
            return (
                <B2B_ContasPagarReceberEmAberto
                    NomeAmigavel={DashSelecionado[0].NomeAmigavel}
                />
            )
        }

        if (DashSelecionado[0].Descricao === 'B2B_NotaFiscal') {
            return (
                <B2B_NotaFiscal
                    NomeAmigavel={DashSelecionado[0].NomeAmigavel}
                />
            )
        }

        if (DashSelecionado[0].Descricao === 'B2B_NotaFiscalServico') {
            return (
                <B2B_NotaFiscalServico
                    NomeAmigavel={DashSelecionado[0].NomeAmigavel}
                />
            )
        }

        if (DashSelecionado[0].Descricao === 'B2B_OrdemServico') {
            return (
                <B2B_OrdemServico
                    NomeAmigavel={DashSelecionado[0].NomeAmigavel}
                />
            )
        }

        if (DashSelecionado[0].Descricao === 'B2B_PedidosPDV') {
            return (
                <B2B_PedidosPDV
                    NomeAmigavel={DashSelecionado[0].NomeAmigavel}
                />
            )
        }

        if (DashSelecionado[0].Descricao === 'B2B_TitulosPendentesVencidos') {
            return (
                <B2B_TitulosPendentesVencidos
                    NomeAmigavel={DashSelecionado[0].NomeAmigavel}
                />
            )
        }
    }
}

export default ReturnDashNativos